// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-ref {
  margin-left: auto;
  font-weight: bold;
  font-size: small;
  text-align: right;
}

ion-item ion-label {
  font-size: medium;
}

ion-card-content, ion-card-header {
  padding: 0px !important;
}

.accommodation-info ion-label {
  display: block;
}
.accommodation-info ion-text {
  color: var(--ion-color-dark) !important;
  font-weight: 550;
}

.overbooked {
  background-color: var(--ion-color-tertiary);
  color: #ffffff;
  font-style: italic;
}

.waitlisted {
  background-color: #f4e04d;
  color: #333333;
}

.warning-message {
  padding: 5px;
  font-size: small;
}

.flight {
  font-weight: bold;
}

.info {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/upcoming-details/upcoming-details.page.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAGI;EACI,iBAAA;AAAR;;AAIA;EACI,uBAAA;AADJ;;AAKI;EACI,cAAA;AAFR;AAKI;EACE,uCAAA;EACA,gBAAA;AAHN;;AAOA;EACI,2CAAA;EACA,cAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,cAAA;AAJJ;;AAOA;EACI,YAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACE,kBAAA;AAJF","sourcesContent":[".booking-ref {\n    margin-left: auto;\n    font-weight: bold;\n    font-size: small;\n    text-align: right;\n}\n\nion-item {\n    ion-label {\n        font-size: medium;\n    }\n}\n\nion-card-content, ion-card-header {\n    padding: 0px !important;\n}\n\n.accommodation-info {\n    ion-label {\n        display: block;\n    }\n\n    ion-text {\n      color: var(--ion-color-dark) !important;\n      font-weight: 550;\n    }\n}\n\n.overbooked {\n    background-color: var(--ion-color-tertiary);\n    color: #ffffff;\n    font-style: italic;\n}\n\n.waitlisted {\n    background-color: #f4e04d;\n    color: #333333;\n}\n\n.warning-message {\n    padding: 5px;\n    font-size: small;\n}\n\n.flight {\n    font-weight: bold;\n}\n\n.info {\n  font-style: italic;;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
